/**
 * we want a welcome message.
 *
 * Cstreet is a _______
 *
 * how it works.
 *
 * How this project is configured.
 *
 *
 *
 * FAQ link
 *
 * */
import {Link, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {fetchWithToken} from "../../api/apiBase";
import {ProjectContext} from "../../contexts/ProjectContext";
import {useAuthInfo} from "@propelauth/react";
import {useParams} from "react-router-dom";
import {Card, CardContent, CardHeader} from "../ui/card";
import {DeveloperProjectConfig, ProjectConfigSchema, VEConfig} from "@models/project";
import {useToast} from "../../hooks/use-toast";
import {RichTextView} from "../ui/richtext";
import {Eligibility, RoundModel} from "../project_conf/round_model";
import {AmountViewExplanation, NamedViewExplanation} from "../bid/bidding_model";
import {Spinner} from "../ui/spinner";
import {GoToVEButton} from "../navButtons/navButton";
import CreateBidButton from "../navButtons/CreateBidButton";


const ExplainVEConfigVisibility = ({ve}: DeveloperProjectConfig) => {
    let dx = "You will get feedback on each VE idea to see where it ranks."
    if (!ve.enable_public && !ve.enable_sharing) {
        return <li>Your VE ideas will only be visible to the client.</li>

    } else if (ve.enable_public) {
        return <>
            <li>All VE ideas are anonymously visible to project bidders.</li>
            {ve.feedback_enabled && <li>{dx}   </li>}
        </>

    } else if (ve.enable_sharing) {
        return <>
            <li>The client may anonymously share VE your ideas with other bidders for their pricing and opinion.</li>
            {ve.feedback_enabled && <li>{dx}   </li>}
        </>
    } else {
        return <></>
    }
}


/**
 * Per project explanation of the process
 *
 * */
export function ProjectBidInfo() {
    const [config, setConfig] = useState<ProjectConfigSchema | null>(null);
    const [round, setRound] = useState<RoundModel | null>(null);
    const {accessToken} = useAuthInfo();
    const {project_id} = useParams();
    const navigate = useNavigate();
    const {toast} = useToast()
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        const fetchData = async () => {
            if (accessToken) {
                try {
                    setIsLoading(true)
                    const [cfg, rnd] = await Promise.all([
                        fetchWithToken(`/projects/${project_id}/config`, accessToken),
                        fetchWithToken(`/projects/${project_id}/current_round`, accessToken),
                    ]);
                    setConfig(cfg);
                    setRound(rnd);
                } catch (err) {
                    toast({
                        title: "Error",
                        description: "Failed to load info: " + JSON.stringify(err),
                        variant: "destructive",
                    })
                } finally {
                    setIsLoading(false)
                }
            }
        }
        fetchData()
    }, [project_id])

    if (isLoading) return <Spinner/>
    if (!config || !round) return <></>

    return <div className={"container"}>
        <Card className={"container"}>
            <CardHeader></CardHeader>
            <CardContent>
                {/*<>Instrucitons to bidders </>*/}
                {config.instructions &&
                    <div className="space-y-2">
                        <strong>Instructions to Bidders</strong>
                        <RichTextView initialValue={config.instructions}/>
                        <br/>
                    </div>
                }

                <div className="space-y-2">
                    <strong>Bidding</strong>
                    <p></p>
                    <ul className="list-disc list-outside pl-5 space-y-2">
                        <li>
                            {round.eligibility === Eligibility.Closed
                                ? "The Project is not accepting Bids at this time"
                                : "The project is accepting Bids"}
                        </li>
                        <li>
                            <span>The Current Round: </span>
                            {round.end_date
                                ? <span>will last until
                                    <strong> {round.end_date.split("T")[0]}</strong>
                                  </span>
                                : <strong>is open indefinitely</strong>
                            }
                        </li>
                        <li>
                            <span>Competing bidder amounts are: </span>
                            <strong>'{round.bid_config.bid_view_mode.amounts}'</strong>
                            <span>- aka{' '} {AmountViewExplanation[round.bid_config.bid_view_mode.amounts]}</span>
                        </li>
                        <li>
                            <span>Bidder names are: </span>
                            <strong>'{round.bid_config.bid_view_mode.names}'</strong>
                            <span>- aka{' '}{NamedViewExplanation[round.bid_config.bid_view_mode.names]}</span>
                        </li>
                        {config.smart_feedback &&
                            <li>You will receive tailored feedback based on your bid.</li>}
                    </ul>
                    <p>We invite you to bid the project
                        <CreateBidButton text={"here"}/>
                    </p>
                </div>


                {config.ve.enabled &&
                    <div className="space-y-1">
                        <br/>
                        <strong>Value Engineering (VE)</strong>
                        <p>
                            As part of the bidding process, you we want your ideas
                            on ways to improve the project and save costs.
                        </p>
                        <ul className="list-disc list-outside pl-5 space-y-2">
                            <ExplainVEConfigVisibility {...config}/>

                        </ul>
                        <p className="space-y-2">We invite you to share your VE ideas
                            <GoToVEButton text={"Here"}/>
                        </p>
                    </div>
                }
            </CardContent>
        </Card>
        {/*<Link to={}>FAQ</Link>*/}
    </div>
}

